import { ImageAssets } from "@/assets";
import styled from "@emotion/styled";
import { Box, Button, IconButton } from "@mui/material";

export const RootBox = styled(Box)({
  width: "100%",
  height: "fit-content",

  display: "flex",
});

export const LeftBox = styled(Box)({
  width: "40%",
  minWidth: 400,

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16,
});

export const RightBox = styled(Box)({
  width: "60%",
  height: "auto",
  minWidth: 600,
  minHeight: "100vh",

  backgroundImage: `linear-gradient(rgba(33, 150, 243, 0.90), rgba(33, 150, 243, 0.90)), url(${ImageAssets.LoginBackgroundImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

export const LoginForm = styled(Box)({
  width: 430,
  maxWidth: "90%",
});

export const LogoBox = styled(Box)({
  paddingBottom: 32,
});

export const CaptchaBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  marginTop: "16px",
});

export const IconBtnReplay = styled(IconButton)({
  marginRight: 2,
});

export const BtnLogin = styled(Button)({
  marginTop: 48,
});

export const CaptchaContainer = styled(Box)({
  width: 280,
  height: "56px",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "4px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
